import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import './admin.css';
import AdminBOSidebar from './Sidebar';
import AppWalkthrough from './components/AppWalkthrough';
import { API_BASE as apiBase, authHeaders } from '../config/api';

const AdminLayout = () => {
  const [showWalkthrough, setShowWalkthrough] = useState(false);

  useEffect(() => {
    const loadThemePreference = async () => {
      try {
        const res = await fetch(`${apiBase}/my/theme-preference`, {
          headers: { 'Content-Type': 'application/json', ...authHeaders() }
        });
        const body = await res.json().catch(() => ({}));

        if (res.ok && body.theme) {
          applyTheme(body.theme);
        } else {
          applyTheme('light');
        }
      } catch (err) {
        console.error('Error loading theme preference:', err);
        applyTheme('light');
      }
    };

    const applyTheme = (theme) => {
      if (theme === 'dark') {
        document.body.classList.add('dark-mode');
        document.body.classList.remove('light-mode');
      } else {
        document.body.classList.add('light-mode');
        document.body.classList.remove('dark-mode');
      }
    };

    loadThemePreference();
  }, []);

  // Check if user has seen walkthrough on component mount
  useEffect(() => {
    const hasSeenWalkthrough = localStorage.getItem('asuma_walkthrough_seen');
    if (!hasSeenWalkthrough) {
      // Show walkthrough after a brief delay to let the app load
      const timer = setTimeout(() => {
        setShowWalkthrough(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleWalkthroughComplete = () => {
    localStorage.setItem('asuma_walkthrough_seen', 'true');
    setShowWalkthrough(false);
  };

  const handleShowWalkthrough = () => {
    setShowWalkthrough(true);
  };

  return (
    <div className="abo-layout">
      <AdminBOSidebar onShowGuide={handleShowWalkthrough} />
      <div className="abo-main">
        <Outlet />
      </div>

      <AppWalkthrough
        visible={showWalkthrough}
        onClose={() => setShowWalkthrough(false)}
        onComplete={handleWalkthroughComplete}
      />
    </div>
  );
};

export default AdminLayout;
